import modal from './modal';
import role from './role';
import question from './question';
import contact from './contact';
import application from './application';
import training from './training';
import {
  actions as qActions,
  connect as qConnect,
  reducers as qReducers
} from '../qoc-redux';

export const actions = Object.assign({}, qActions, {
  ...qActions,
  ...application.actions,
  modal: modal.actions,
  role: role.actions,
  question: question.actions,
  contact: contact.actions,
  training: training.actions
});

export const connect = Object.assign({}, qConnect, {
  ...qConnect,
  ...application.connect,
  modal: modal.connect,
  role: role.connect,
  question: question.connect,
  contact: contact.connect,
  training: training.connect
});

export const reducers = Object.assign({}, qReducers, {
  ...qReducers,
  ...application.reducer,
  modal: modal.reducer,
  role: role.reducer,
  question: question.reducer,
  contact: contact.reducer,
  training: training.reducer
});

const redux = {
  actions,
  connect,
  reducers
};

export default redux;



// WEBPACK FOOTER //
// ./src/reducers/index.js